import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { DatePicker } from 'material-ui-pickers';
import DropzoneComponent from 'react-dropzone-component';

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as documentdetails from '../../../actions/documentdetails';
import * as fileupload from '../../../actions/fileupload';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as regData from '../../../../appConstants';
import { ApiUrl } from '../../../api/config';

import MUISelector from "../../muiselector";
import TableCell from './tablecell';

import { filter, map, pickBy, remove, union } from 'lodash'

const mimeTypes = "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
class AddDocument extends Component {

    constructor(props) {
        super(props);
        this.state = {
            committee_id: Number(this.props.loginUser.data.committee_id),
            id: this.props.params.id,
            setValue: false,
            document: { folderId: '', priority: '', title: '', createdOn: '', lastUpdatedOn: '', status: '', customer_id: '', commiteeId: '', fileCDS: [], file_user: [] },
            newfile: '',
            isFileupload: false
        };

        this.djsConfig = {
            previewsContainer: false,
            addRemoveLinks: true,
            // acceptedFiles: "image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
           // acceptedFiles: "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            acceptedFiles: "application/pdf",
           
            headers: { Authorization: 'Bearer ' + localStorage.getItem('TOKEN') }
        };
        console.log('ApiUrl', ApiUrl);
        this.componentConfig = {
            iconFiletypes: ['.jpg', '.png', '.pdf', '.doc', '.docx'],
            showFiletypeIcon: true,
            postUrl: ApiUrl + '/file/uploadcds'
        };

        // If you want to attach multiple callbacks, simply
        // create an array filled with all your callbacks.
        this.callbackArray = [() => console.log('Hi!'), () => console.log('Ho!')];

        // Simple callbacks work too, of course
        // this.callback = () => console.log('Hello!');
        this.callback = () => {
            console.log('callback');
            this.setState({ isFileupload: true });
        }

        this.success = (file) => {
            let res = JSON.stringify(file.xhr.response);
            res = JSON.parse(file.xhr.response);
            // console.log('file.xhr.response', file.xhr.response);
            // console.log('res', res);
            // console.log('uploaded', res.type);
            // console.log('uploaded1', file.xhr.response.uploaded);
            res.description = this.state.newfile.filedescription;
            if (!this.state.document.fileCDS)
                this.state.document.fileCDS = [];
            this.state.document.fileCDS.push(res);
            this.setState({ newfile: this.state.newfile });

        };

        this.complete = () => {
            console.log('complete');
            this.setState({ newfile: '', isFileupload: false });
        }

        this.error = () => {
            console.log('error');
            // this.setState({ newfile: '', isFileupload: false });
        }

        this.removedfile = file => console.log('removing...', file);

        this.dropzone = null;
    }

    componentDidMount() {
        // console.log('this.state.id', this.state.id)
        if (this.state.id) {
            // console.log(this.props.loginUser.data.committee_id,'this.state.id', this.state.id)
            this.props.actions.getDocumentDetails(this.state.id);
        }
        else
            this.state.document = { folderId: '', priority: '', title: '', createdOn: '', lastUpdatedOn: '', status: '', customer_id: '', commiteeId: '', fileCDS: [], file_user: [] }
        this.props.actions.loadswitchercommittees();
        this.props.actions.getTeamUserList(this.state.committee_id);
        $('.dz-message span').html('Choose File');
    }

    handleChange(field, e) {
        if (field == "filedescription") {
            const newfile = Object.assign({}, this.state.newfile, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'newfile': newfile }));
        }
        else {
            const document = Object.assign({}, this.state.document, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'document': document }));
        }
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.props.actions.getTeamUserList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log(this.state.document)
        if (this.state.document.folderId) {
            // this.state.document.file_user = filter(this.state.document.file_user, { status: true })
            // this.state.document.fileCDS = pickBy(this.state.document.fileCDS, value => value.tempFileId);
            // console.log(this.state.document)
            this.props.actions.updateDocumentDetails(this.state.committee_id, this.state.document);
        }
        else
            this.props.actions.addDocumentDetails(this.state.committee_id, this.state.document);
    }

    handleFileSelected(file) {
        let filedescription = this.state.newfile.filedescription ? this.state.newfile.filedescription : ''
        let newfile = { 'filedescription': filedescription, 'file': file.target.files[0] }
        this.setState({ 'newfile': newfile });
        // console.log(this.state)
        let formData = new FormData();
        formData.append('file', file.target.files[0])
        this.props.actions.fileUploadcds(formData)
        this.setState({ isFileUploaded: true });
        if (this.refs.fileUpload)
            this.refs.fileUpload.value = null;
    }

    getUpdateFileDetails = (data) => {
        // Find item index using _.findIndex
        var index = _.findIndex(this.state.document.fileCDS, { fileId: data.fileId });
        // Replace item at index using native splice
        this.state.document.fileCDS.splice(index, 1, data);
        this.setState({ 'setValue': true });
    }
    getDeleteFileDetails = (data) => {
        if (data && data.fileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.document.fileCDS, { fileId: data.fileId });
            // Replace item at index using native splice
            this.state.document.fileCDS.splice(index, 1);
        }
        else if (data && data.tempFileId) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.document.fileCDS, { tempFileId: data.tempFileId });
            // Replace item at index using native splice
            this.state.document.fileCDS.splice(index, 1);
        }
        this.setState({ 'setValue': true });
    }
    render() {
        const config = this.componentConfig;
        const djsConfig = this.djsConfig;
        // For a list of all possible events (there are many), see README.md!
        const eventHandlers = {
            init: dz => this.dropzone = dz,
            drop: this.callbackArray,
            addedfile: this.callback,
            success: this.success,
            error: this.error,
            removedfile: this.removedfile,
            queuecomplete: this.complete,
        }

        const { match, loginUser, documentDetails, params, teamDetails } = this.props;
        let result = null;
        let isFileupload = this.state.isFileupload;
        if ((documentDetails && documentDetails.Status) || (teamDetails && teamDetails.Status) || (isFileupload)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (documentDetails && documentDetails.documentdetails && documentDetails.apiGetResult && !this.state.setValue) {
            this.state.document = documentDetails.documentdetails;
            this.setState({ committee_id: Number(this.state.document.commiteeId) })
            this.state.setValue = true;
            let committee_users = this.state.document.committee_users;
            let file_user = this.state.document.file_user;
            map(file_user, function (el) {
                remove(committee_users, { 'id': el.id })
            });
            this.state.document.file_user = union(file_user, committee_users);
            // console.log('fileuser',this.state.document.file_user);
        }
        else if (!this.state.id && teamDetails && teamDetails.teamuserList && teamDetails.apiGetResult)
            this.state.document.file_user = teamDetails.teamuserList;

        // if (fileupload && fileupload.filedetails && this.state.isFileUploaded) {
        //     fileupload.filedetails.description = this.state.newfile.filedescription;
        //     if (!this.state.document.fileCDS)
        //         this.state.document.fileCDS = [];
        //     this.state.document.fileCDS.push(fileupload.filedetails);
        //     this.setState({ isFileUploaded: false, newfile: '' });
        // }
        let _TeamList = null
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }
        let _fileList = null
        // console.log('this.state.document.fileCDS', this.state.document.fileCDS)
        const fileList = this.state.document.fileCDS;
        if (fileList && fileList.length > 0) {
            _fileList = fileList.map((_data, index) => {
                return (<TableCell key={index} data={_data} index={index} getUpdateFileDetails={this.getUpdateFileDetails.bind(this)}
                    folderId={this.state.document.folderId} getDeleteFileDetails={this.getDeleteFileDetails.bind(this)} />);
            })
        }

        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Add Library Folder" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <FormControl className="w-100 mb-2 col-md-3">
                            <InputLabel htmlFor="age-simple">Team Switcher</InputLabel>
                            <Select
                                value={this.state.committee_id}
                                onChange={this.handleChangeTeam.bind(this)}
                                input={<Input id="age-simple" />}
                                disabled={this.state.id ? true : false}
                            >
                                {_TeamList}
                            </Select>
                        </FormControl>
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">Library Folder Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-4 pb-4">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="title" label="Library Folder Name"
                                                validators={['required', regData.regexAlphaNumeric, regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required', regData.messageAlphaNumeric, regData.messageLength]}
                                                value={this.state.document.title} onChange={this.handleChange.bind(this, 'title')} />
                                        </div>
                                        <div className="col-12">
                                            <MUISelector userList={this.state.document.file_user} />
                                        </div>
                                    </div>

                                    <Card className="shadow border-2">
                                        <CardBody>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <h3 className="card-title">File Details</h3>
                                                </div>
                                                <div className="col-md-8">
                                                    <TextValidator margin="normal" className="mt-0 mb-4 col-md-12"
                                                        name="filedescription" label="File Description" multiline={true}
                                                        //validators={['required',regData.regexMultiLineExp,regData.regexMultiLineExpLength]}
                                                        //errorMessages={['This field is required',regData.messageMultilineRegexEx,regData.messageMultilineLength]}
                                                        value={this.state.newfile ? this.state.newfile.filedescription : ''} onChange={this.handleChange.bind(this, 'filedescription')} />
                                                    <p class="pt-2">(Maximum size of the file should not exceed 100MB)</p>
                                                </div>
                                                <div className="col-4">
                                                    {/* <input type="file" accept={mimeTypes} id="fileUpload" ref="fileUpload" className="hidden" onChange={this.handleFileSelected.bind(this)} />
                                                    <label htmlFor="fileUpload">
                                                        <Button variant="raised" component="span" className="jr-btn bg-primary text-white">Choose file</Button>
                                                    </label>
                                                    <label className="m-2">{this.state.newfile && this.state.newfile.file ? this.state.newfile.file.name : "No file chosen"}</label> */}
                                                    <DropzoneComponent config={config} eventHandlers={eventHandlers} djsConfig={djsConfig}
                                                        className='bg-primary jr-btn text-white' />
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="table-responsive-material">
                                                        <table className="default-table table-unbordered table table-lg table-hover">
                                                            <thead className="th-border-b">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>File Name</th>
                                                                    <th>Description</th>
                                                                    <th className="status-cell text-right">Actions</th>
                                                                    <th />
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {_fileList}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/document/document-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { loginUser, teamDetails, documentDetails, fileupload } = state;
    const { match } = ownProps;
    return { match, loginUser, teamDetails, documentDetails, fileupload, params: ownProps.match.params }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, loadswitchercommittees, documentdetails, fileupload), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddDocument));



// WEBPACK FOOTER //
// ./app/documentdetails/adddocument/index.js